import { ApiDomain } from '../types';

const mkApiErrorMessage = (domain: ApiDomain, endpoint: string, errorCode: string) =>
  `api.error.${domain}.${endpoint}.${errorCode}`;

export default mkApiErrorMessage;
